export const MISSION_REFERRAL_SIGN_UP_SOURCE = 'mission-referral';
